export type Review = {
  title: string
  quote: string
  name: string
  location: string
}

export const reviews: Review[] = [
  {
    title: 'True professionals',
    quote:
      'Mike was the man! Very professional and the job was done to exceed my expectations. I’ll only use and refer him and this company to anyone I know.',
    name: 'Robby Doughtery',
    location: 'Henderson, NV',
  },
  {
    title: 'A+++',
    quote:
      'They removed all my flooring and put in new flooring. Amazing job. Painted the whole house as well. Great work!',
    name: 'J. Nelson',
    location: 'Summerlin, NV',
  },
  {
    title: 'Reliable',
    quote:
      'We have recommended them for our tear-outs for a while now. They have always been on time and we’ve received many compliments from our customers about them. Keep up the good work guys.',
    name: 'Closet And Storage',
    location: 'North Las Vegas, NV',
  },
]

export const processSteps = [
  {
    title: 'Call or request a quote',
    text: 'Tell us what needs fixing. Send photos if you have them — we’ll respond within one business day.',
  },
  {
    title: 'Get a clear, fixed price',
    text: 'We walk the job, explain the fix and give you a written quote. No surprise add-ons later.',
  },
  {
    title: 'We fix it — guaranteed',
    text: 'On time, clean job site, and backed by our quality guarantee. If it’s not right, we make it right.',
  },
]
